import React from "react";
import { Alert } from "antd";

export interface PlotMatrixJsonSourceBannerProps {
  isHistoricalVersion: boolean;
  generatedAt: string;
}

const PlotMatrixJsonSourceBanner: React.FC<PlotMatrixJsonSourceBannerProps> = ({
  isHistoricalVersion,
  generatedAt,
}) => (
  <Alert
    type="info"
    showIcon
    style={{ marginBottom: 12 }}
    message="Dev-mode diagnostic view"
    description={`Built from a fresh JSON snapshot of the ${
      isHistoricalVersion ? "selected historical BOQ version" : "latest saved BOQ version"
    }, fetched directly from the boq-versions API — independent of any unsaved edits on this page. Generated at ${new Date(
      generatedAt,
    ).toLocaleString()}.`}
  />
);

export default PlotMatrixJsonSourceBanner;
